// extracted by mini-css-extract-plugin
export default {"outer":"CarouselPC_outer__a0wbR","inner":"CarouselPC_inner__YKo+A","slide--current":"CarouselPC_slide--current__61hBh"};